// Add your JS customizations here
import Swiper from 'swiper/bundle';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ClipboardJS from 'clipboard';

gsap.registerPlugin(ScrollTrigger);

//Init web ticker
const speed = 150;
let target = document.querySelector(".news_gsap");
let original_html = target.innerHTML;
let new_html = "<div class='ticker-items'>" + original_html + "</div>";
target.innerHTML = new_html;
target.innerHTML += new_html;

let tickerWidth = document.querySelector(".ticker-items").offsetWidth;
let initDuration = tickerWidth / speed;

gsap.to(".ticker-items", {
    duration: initDuration,
    xPercent: -100,
    ease: "none",
    repeat: -1
});




// Init swiper 
var mySwiper = new Swiper(".artist-features .swiper-container", {
    spaceBetween: 1,
    // slidesPerView: 3.8,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
    spaceBetween: 20,
    autoplay: {
        delay: 3000,
      },
    breakpoints: {
        // when window width is >= 320px
        0: {
            slidesPerView: 1.5,
        },
        // when window width is >= 640px
        768: {
            slidesPerView: 3.8,
        }
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

let mobileSwiper = new Swiper(".artist-collection .swiper-container", {
    spaceBetween: 20,
    //slidesPerView: 1.3,
    roundLengths: true,
    autoplay: {
        delay: 3000,
      },
    loop: true,
    breakpoints: {
        // when window width is >= 320px
        0: {
            slidesPerView: 1.3,
            centeredSlides: true,
        },
        // when window width is >= 640px
        768: {
            slidesPerView: 2.5,
            centeredSlides: true,
        },
        992: {
            slidesPerView: 2.5,
            centeredSlides: true,
        },
        993: {
            slidesPerView: 4,
            centeredSlides: false,
        }
    },
});



//Init gsap animations
window.addEventListener('DOMContentLoaded', () => {
    initGSAP();
})

function initGSAP() {
    //Animations
    /* ---- Slider Animation ---- */
    const slider_content = document.querySelectorAll('.audrey-homepage-content .video-header__content > *');
    gsap.fromTo(
        slider_content,
        { opacity: 0, y: 20 },
        {
            opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: slider_content[0],
                start: 'top 80%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* ---- Section 2 Animation ---- */
    const section_2 = document.querySelectorAll('.section2 .container > *');
    gsap.fromTo(
        section_2,
        { opacity: 0, x: 50 },
        {
            opacity: 1, x: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_2[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );


    /* ---- Form Animation ---- */
    const section_3 = document.querySelectorAll('.competition-form .container > *:not(.artworks-carousel)');
    gsap.fromTo(
        section_3,
        { opacity: 0, x: -50 },
        {
            opacity: 1, x: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_3[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );
    const section_3_1 = document.querySelectorAll('.competition-form .container .VueCarousel-slide');
    gsap.fromTo(
        section_3_1,
        { opacity: 0 },
        {
            opacity: 1, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_3_1[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* ---- Section 4 Animation ---- */
    const section_4 = document.querySelectorAll('.artist-section .row > div');
    gsap.fromTo(
        section_4,
        { opacity: 0, y: -30 },
        {
            opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_4[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* -- Section 5 Animation -- */
    const section_5 = document.querySelectorAll('.artist-features .container > *');
    gsap.fromTo(
        section_5,
        { opacity: 0, y: -30 },
        {
            opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_5[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );
    const section_5_1 = document.querySelectorAll('.artist-features .swiper-container .swiper-wrapper .swiper-slide');
    gsap.fromTo(
        section_5_1,
        { opacity: 0 },
        {
            opacity: 1, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_5_1[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* -- Section 6 Animation -- */
    const section_6 = document.querySelectorAll('.artist-qualifications .container > *');
    gsap.fromTo(
        section_6,
        { opacity: 0 },
        {
            opacity: 1, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_6[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* -- Section 7 Animation -- */
    const section_7 = document.querySelectorAll('.artist-collection > .container > *:not(.collection)');
    gsap.fromTo(
        section_7,
        { opacity: 0, y: 20 },
        {
            opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_7[0],
                start: 'top 80%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );
    const section_7_1 = document.querySelectorAll('.artist-collection > .container > .collection .item');
    gsap.fromTo(
        section_7_1,
        { opacity: 0 },
        {
            opacity: 1, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_7_1[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* -- mobile share Animation --*/
    const section_8 = document.querySelectorAll('.mobile-share > .container > *');
    gsap.fromTo(
        section_8,
        { opacity: 0 },
        {
            opacity: 1, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_8[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );

    /* footer animations -- */
    const section_footer = document.querySelectorAll('#wrapper-footer-full div#footer-full-content>.row > div');
    gsap.fromTo(
        section_footer,
        { opacity: 0, y: 20 },
        {
            opacity: 1, y: 0, duration: 1, stagger: 0.3, ease: 'power2.out', delay: 0.3, scrollTrigger: {
                trigger: section_footer[0],
                start: 'top 90%', // Adjust the trigger position as needed
                end: 'bottom 20%', // Adjust the end position as needed
                scrub: false,
            }
        }
    );
}

// Listen to docuemtn body class change to re-init the animations
const targetElement = document.body;

// Callback function to execute when a mutation (class change) is observed
const mutationCallback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Class change detected, you can access the current class using targetElement.className
            if (targetElement.classList.contains('changed')) {
                initGSAP();
            }

        }
    }
};

// Create a new MutationObserver
const observer = new MutationObserver(mutationCallback);

// Configure and start observing changes
const config = { attributes: true, attributeFilter: ['class'] };
observer.observe(targetElement, config);

//Init clipboard js
const clipboard = new ClipboardJS('.copy-btn');
clipboard.on('success', function () {
    document.getElementById('clipboard-message').textContent = 'COPIED TO CLIPBOARD'
});


//Share link
document.getElementById('share-link').addEventListener('click', () => {
    if (navigator.share) {
        navigator.share({
            title: document.title,
            text: 'WIN A ONE-OF-A-KIND ARTWORK BY ARTIST ANTHONY RICCIARDI.',
            url: window.location.href
        })
            .then(() => console.log('Shared successfully'))
            .catch(error => console.error('Error sharing:', error));
    } else {
        alert('Sharing is not supported in your browser.');
    }
})